// extracted by mini-css-extract-plugin
module.exports = {"btn":"Search_btn__1XSS1","search":"Search_search__kehRK"};